import { Collection } from 'modules/core/lib/mobx-rest'

import Review from 'modules/documents/store/models/Review'

class Reviews extends Collection<Review> {
  get cacheKey(): string {
    return 'reviews'
  }

  get indexes() {
    return ['reviewable_type', 'reviewable_id']
  }

  model() {
    return Review
  }

  filterByDocument(documentId: number | undefined): Review[] {
    return this.filter({
      reviewable_type: 'Document',
      reviewable_id: documentId,
    })
  }
}

// TODO: Deprecate
const singleton: Reviews = new Reviews()
export default singleton
